import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('LanguageService', LanguageService);

  LanguageService.$inject = ['$translate', '$filter', 'RestResource', 'UtilService'];

  function LanguageService($translate, $filter, RestResource, UtilService) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'languages';

    var service = {
      getLanguages: getLanguages,
      changeLanguageStatus: changeLanguageStatus,
      changeLanguageDefault: changeLanguageDefault,
      tabs: tabs,
    };

    return service;

    ////////////////

    function getLanguages(filterCriteria) {
      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: response.meta,
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function changeLanguageStatus(item) {
      utils.changeItemStatus(apiUrl + '/' + item.id, item);
    }

    function changeLanguageDefault(item, getItemsCallback) {
      var url = apiUrl + '/' + item.id;

      item.is_default = !item.is_default; // Change and refresh at once

      function success() {
        var msg = $translate('CHANGED_DEFAULT_LANGUAGE');
        utils._successMsg(msg);

        return getItemsCallback();
      }

      function failure() {}

      return RestResource.request('put', url, { language: item }, success, failure);
    }

    function tabs() {
      return [
        { name: 'LANGUAGES', url: 'languages' },
        { name: 'CURRENCIES', url: 'currencies' },
      ];
    }
  }
})();
